import { LivetestPublicLiveTest, PublicTest } from "@/queries/types";

export function getTestResultsScreen(
  test: PublicTest,
  liveTest: LivetestPublicLiveTest,
) {
  switch (liveTest.results?.result) {
    case "passed":
      return test.passed_screen;
    case "not_passed":
      return test.not_passed_screen;
    case "no_threshold":
      return test.no_threshold_screen;
    default:
      return test.no_threshold_screen;
  }
}
